import ApiService from '@/services/ApiService';

export default {
  startDay() {
    return ApiService().post('/work-day/start');
  },
  endDay(data) {
    return ApiService()
      .post(
        '/work-day/end',
        ApiService().formData(data),
        true,
        'multipart/form-data',
      );
  },
  checkShift() {
    return ApiService().post('/work-day/end', { checkShift: true });
  },
  infoDay() {
    return ApiService().get('/work-day/info');
  },
  getMonthReport(data) {
    return ApiService().post('/work-day/month-report', data);
  },
  printMonthReport(data) {
    return ApiService().post(
        '/work-day/print-month-report',
        ApiService().formData(data),
        true,
        'multipart/form-data'
      );
  }
};
